import { gql } from '@apollo/client';
import {
  AdminNotificationsFragment,
  FormatSettingFragment,
  UserGroupFragment,
} from './fragments';
import { ErrorFragment } from '../fragments';

export const ROLE_CREATE = gql`
  mutation RoleCreate($input: RoleCreateInput!) {
    roleCreate(input: $input) {
      entity {
        id
        name
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ROLE_EDIT = gql`
  mutation RoleEdit($input: RoleEditInput!) {
    roleEdit(input: $input) {
      entity {
        id
        name
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ROLE_DISABLE = gql`
  mutation RoleDisable($input: RoleDisableInput!) {
    roleDisable(input: $input) {
      disabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ROLE_ENABLE = gql`
  mutation RoleEnable($input: RoleEnableInput!) {
    roleEnable(input: $input) {
      enabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const ROLE_DEFAULT = gql`
  mutation RoleDefault($input: RoleDefaultInput!) {
    roleDefault(input: $input) {
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_EDIT = gql`
  mutation UserEdit($input: UserEditInput!) {
    userEdit(input: $input) {
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;
export const USER_DISABLE = gql`
  mutation UserDisable($input: UserDisableInput!) {
    userDisable(input: $input) {
      disabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_ENABLE = gql`
  mutation UserEnable($input: UserEnableInput!) {
    userEnable(input: $input) {
      enabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_GROUP_CREATE = gql`
  mutation UserGroupCreate($input: UserGroupCreateInput!) {
    userGroupCreate(input: $input) {
      entity {
        ...UserGroupFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
  ${UserGroupFragment}
`;

export const USER_GROUP_EDIT = gql`
  mutation UserGroupEdit($input: UserGroupEditInput!) {
    userGroupEdit(input: $input) {
      entity {
        ...UserGroupFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
  ${UserGroupFragment}
`;

export const USER_GROUP_DISABLE = gql`
  mutation UserGroupDisable($input: UserGroupDisableInput!) {
    userGroupDisable(input: $input) {
      disabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_GROUP_ENABLE = gql`
  mutation UserGroupEnable($input: UserGroupEnableInput!) {
    userGroupEnable(input: $input) {
      enabled
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_INVITE_RESEND = gql`
  mutation UserInviteResend($input: UserInviteResendInput!) {
    userInviteResend(input: $input) {
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_INVITE = gql`
  mutation UserInvite($input: UserInvitesInput!) {
    userInvite(input: $input) {
      errors {
        ...ErrorFields
      }
      invites {
        user {
          id
          name
          email
        }
        error
      }
    }
  }
  ${ErrorFragment}
`;

export const USER_REVOKE = gql`
  mutation UserRevoke($input: UserRevokeInput!) {
    userRevoke(input: $input) {
      errors {
        ...ErrorFields
      }
      revoked
    }
  }
  ${ErrorFragment}
`;

export const FORMAT_SETTING_EDIT = gql`
  mutation FormatSettingEdit($input: FormatSettingEditInput!) {
    formatSettingEdit(input: $input) {
      entity {
        ...FormatSettingFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${FormatSettingFragment}
  ${ErrorFragment}
`;

export const ADMIN_NOTIFICATIONS_SET = gql`
  mutation AdminNotificationSettingsSet(
    $input: AdminNotificationSettingsInput!
  ) {
    adminNotificationSettingsSet(input: $input) {
      entity {
        ...AdminNotificationSettingsFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
  ${AdminNotificationsFragment}
`;
